import styled from 'styled-components';
import { colours, media } from '../../../../stylings';

export const Container = styled.div<{ $isNavbarSticky: boolean }>`
  display: none;
  height: calc(100vh - ${({ $isNavbarSticky }) => ($isNavbarSticky ? '96px' : '16px')});
  margin: 0;
  padding: 0px;

  position: sticky;
  top: ${({ $isNavbarSticky }) => ($isNavbarSticky ? '88px' : '8px')};
  /* stylelint-disable-next-line plugin/no-low-performance-animation-properties */
  transition: top 0.5s linear, height 0.5s linear;
  width: 100%;

  @media ${media.greaterThan('lg')} {
    display: initial;
  }

  @media screen and (prefers-reduced-motion: reduce) {
    .overlayscrollbars-plp-srp {
      height: calc(100vh - ${({ $isNavbarSticky }) => ($isNavbarSticky ? '96px' : '16px')});
      overflow: visible !important;
      /* stylelint-disable-next-line plugin/no-low-performance-animation-properties */
      transition: none;
    }
  }

  .overlayscrollbars-plp-srp {
    height: calc(100vh - ${({ $isNavbarSticky }) => ($isNavbarSticky ? '96px' : '16px')});
    overflow: visible !important;
    /* stylelint-disable-next-line plugin/no-low-performance-animation-properties */
    transition: height 0.5s linear;
  }

  .plp-srp-theme {
    &.os-scrollbar {
      --os-size: 24px;

      --os-track-bg: ${colours.LIGHT_GREY_2};
      --os-track-bg-hover: ${colours.LIGHT_GREY_2};
      --os-track-bg-active: ${colours.LIGHT_GREY_2};

      --os-handle-bg: ${colours.MID_GREY};
      --os-handle-bg-hover: ${colours.MID_GREY};
      --os-handle-bg-active: ${colours.MID_GREY};
      --os-handle-border-radius: 12px;
      --os-handle-perpendicular-size: 16px;
      --os-handle-perpendicular-size-hover: 16px;
      --os-handle-perpendicular-size-active: 16px;
      --os-handle-max-size: 200px;

      right: -30px;
    }
    &.os-scrollbar-vertical {
      background: ${colours.LIGHT_GREY_2};

      --os-padding-axis: 4px;
    }

    & .os-scrollbar-track .os-scrollbar-handle {
      left: 0;
      margin: 0 auto;
    }
  }
`;
